// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import VueSweetalert2 from 'vue-sweetalert2';
import VueProgressBar from 'vue-progressbar';

import VueI18n from 'vue-i18n';
import store from './store/index';
import Toasted from 'vue-toasted';
import VAnimateCss from 'v-animate-css';
import BootstrapVue from 'bootstrap-vue';
import VueCarousel from 'vue-carousel';
import VTooltip from 'v-tooltip';
import vueTopprogress from 'vue-top-progress';
import VuejsDialog from 'vuejs-dialog';


// include the default style
import 'vuejs-dialog/dist/vuejs-dialog.min.css';

import fullscreen from 'vue-fullscreen';
export const bus = new Vue();

import vSelect from 'vue-select';
Vue.component('v-select', vSelect);
import InfiniteLoading from 'vue-infinite-loading';
Vue.use(InfiniteLoading, {
  /* options */
});
import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: 'static/images/404.jpg',
  loading: 'static/images/loading.svg',
  attempt: 1
});
// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
Vue.use(fullscreen);
Vue.use(vueTopprogress);

Vue.use(VueCarousel);
Vue.use(BootstrapVue);
Vue.use(VAnimateCss);
Vue.use(Toasted, {
  iconPack: 'fontawesome', // set your iconPack, defaults to material. material|fontawesome|custom-class
});
Vue.use(VueSweetalert2);
Vue.use(VTooltip);

import en from './i18n/en_US.js';
import fr from './i18n/fr_FR.js';

require('./includes');

import filters from './filters';

filters.forEach(f => {
  Vue.filter(f.name, f.execute);
});

Vue.use(VueI18n);
Vue.config.productionTip = false;
Vue.use(VueProgressBar, {
  color: 'rgb(248, 151, 5)',
  failedColor: 'red',
  height: '5px',
});

let locale = 'fr';
bus.$on('setFormLang', lang => {
  locale = lang;
});

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: locale, // set locale
  messages: {
    en: en,
    fr: fr,
  },
});
/* eslint-disable no-new */
window.eventHub = new Vue();
window.generateClass = function() {
  let text = 'c';
  var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }
  return text;
};
Vue.mixin({
  methods: {
    generateClass() {
      let text = 'c';
      var possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (var i = 0; i < 5; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
      }
      return text;
    },
  },
});

new Vue({
  el: '#app',
  router,
  i18n,
  store: store,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js